<template>
    <v-app>
        <v-navigation-drawer v-model="drawer" disable-resize-watcher fixed app>
            <v-list dense>
                <v-list-tile value="true" v-for="(item, i) in items" :key="i" :to="item.link" v-show="item.show">
                    <v-list-tile-action>
                        <v-icon v-html="item.icon"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title v-text="item.title"></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile @click="openPerfilModal" v-show="isLoggedIn">
                    <v-list-tile-action>
                        <v-icon>person</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Perfil</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile @click="logout" v-show="isLoggedIn">
                    <v-list-tile-action>
                        <v-icon>launch</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Salir</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>



            </v-list>
        </v-navigation-drawer>

        <v-toolbar dark fixed app>


            <v-btn class="hidden-sm-and-up" icon @click.stop="drawer = !drawer">
                <v-icon>menu</v-icon>
            </v-btn>

            <v-spacer class="hidden-sm-and-up"></v-spacer>
            <v-toolbar-side-icon>
                <router-link to="/"><v-img :src=logo height="30px" width="40px"></v-img></router-link>
            </v-toolbar-side-icon>

            <v-toolbar-title class="hidden-xs-only mx-1 px-1"><v-btn class="mx-1 px-1" flat to="/" v-text="title"
                    exact></v-btn></v-toolbar-title>

            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-xs-only">

            </v-toolbar-items>
            <v-toolbar-items class="hidden-xs-only">
                <v-btn v-show="!isLoggedIn" rigth to="/contacto" flat>Contacto</v-btn>
                <v-btn v-show="!isLoggedIn" rigth to="/" flat>Inicio </v-btn>
            </v-toolbar-items>




            <v-toolbar-items class="hidden-xs-only">
                <v-btn v-show="isLoggedIn && isAdmin" rigth to="/admin/disciplina/lista" flat>Disciplinas</v-btn>
                <v-btn v-show="isLoggedIn && isAdmin" rigth to="/admin/pagos/lista" flat>Pagos en revisión</v-btn>
                <v-btn v-show="isLoggedIn && isAdmin" rigth to="/admin/evento/lista" flat>Eventos </v-btn>
                <v-btn v-show="isLoggedIn && isAdmin" rigth to="/admin/organizadores" flat>Organizadores </v-btn>
                <v-btn v-show="isLoggedIn" to="/backoffice/dashboard">Panel Inicio</v-btn>
                <v-btn v-show="isLoggedIn && isOrganizador" to="/organizador/evento/lista">Mis Eventos</v-btn>
            </v-toolbar-items>

            <div class="hidden-xs-only" v-show="isLoggedIn">

                <v-menu bottom left v-show="isLoggedIn">
                    <template v-slot:activator="{ on }">
                        <v-toolbar-title v-on="on">
                            <v-icon dark>account_circle</v-icon>
                        </v-toolbar-title>
                    </template>

                    <v-list>
                        <v-list-tile>
                            <v-list-tile-title>{{ nombreUsuario }} </v-list-tile-title>
                        </v-list-tile>
                        <v-divider></v-divider>

                        <v-list-tile @click="openPerfilModal">
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>Perfil</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="logout">
                            <v-list-tile-action>
                                <v-icon>launch</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-title v-show="isLoggedIn">Salir</v-list-tile-title>
                        </v-list-tile>

                    </v-list>
                </v-menu>
            </div>

        </v-toolbar>

        <v-content>


            <v-dialog v-model="showAlert" hide-overlay width="400">
                <v-card :color="(alertType == 'error') ? 'red' : 'green'" dark>
                    <v-card-text>
                        {{ message }}
                    </v-card-text>
                </v-card>
            </v-dialog>

            <router-view />
        </v-content>

        <v-footer class="app-footer" padless>
            <div class="footer-inner">
                <v-container class="footer-container">
                    <div class="footer-top">
                        <router-link to="/" class="footer-brand">Finishtime</router-link>
                        <nav class="footer-nav">
                            <router-link to="/" class="footer-nav-link">Inicio</router-link>
                            <router-link to="/contacto" class="footer-nav-link">Contacto</router-link>
                        </nav>
                    </div>
                    <div class="footer-bottom">
                        <span class="footer-copy">© {{ new Date().getFullYear() }} Finishtime. Chivilcoy, Buenos Aires.</span>
                        <span class="footer-contact-line">
                            <a href="mailto:finishtimechivilcoy@gmail.com" class="footer-contact-link">finishtimechivilcoy@gmail.com</a>
                            <span class="footer-sep">·</span>
                            <a href="tel:5492346654774" class="footer-contact-link">2346 65-4774</a>
                        </span>
                        <div class="footer-auth">
                            <span v-show="isLoggedIn" class="footer-welcome">Hola, {{ nombreUsuario }}</span>
                            <v-btn v-show="!isLoggedIn" to="/login" flat class="footer-btn-ingresar">Ingresar</v-btn>
                            <v-btn v-show="isLoggedIn" @click="logout" flat class="footer-btn-salir">Salir</v-btn>
                        </div>
                    </div>
                </v-container>
            </div>
        </v-footer>
        <perfil ref="perfilModal">

        </perfil>

        <!-- Botón flotante WhatsApp -->
        <a
            href="https://wa.me/5492346654774"
            target="_blank"
            rel="noopener noreferrer"
            class="whatsapp-float"
            aria-label="Contactar por WhatsApp"
        >
            <svg class="whatsapp-float-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
        </a>
    </v-app>
</template>

<script>

import Vuex from 'vuex'
import auth from './api/auth'
import Perfil from './components/admin/Perfil'
export default {
    components: { 'perfil': Perfil },
    data() {
        return {
            column1Links: [
                { title: 'Inicio', link: '/' },
                { title: 'Contacto', link: '/contacto' },
               // { title: 'Terminos de Privacidad', link: '/public/privacy-policy' }
            ],
            contactInfos: [
                { title: 'Telefono', value: '2346654774' },
                { title: 'Email', value: 'finishtimechivilcoy@gmail.com' },
                { title: 'Ubicacion', value: 'Chivilcoy, Buenos Aires, Arg.' }
            ],
            column3Links: [
                { title: 'Mis Eventos', link: '/organizador/evento/lista' },
                { title: 'Novedades', link: '/organizador/home' }
            ],

            icons: [
                'fa-facebook',
                'fa-twitter',
                'fa-google-plus',
                'fa-linkedin',
                'fa-instagram'
            ],
            on: false,
            logo: 'logo.png',
            image_url: './logo',
            clipped: false,
            drawer: false,
            fixed: false,
            miniVariant: false,
            title: 'FinishTime Inscripciones'
        }
    },
    methods: {
        logout() {
            auth.logout()
        },
        openPerfilModal() {
            this.$refs.perfilModal.open();
        }
    },
    computed: {
        ...Vuex.mapGetters("auth", ["isLoggedIn", "isAdmin", "isOrganizador", "nombreUsuario"]),
        ...Vuex.mapState("app", ["showAlert", "alertType", "message"]),
        ...Vuex.mapState("auth", ["user.name"]),
        showAlert: {
            set: function (newValue) {
                this.$store.commit('app/SET_SHOW', newValue);
            },
            get: function () {
                return this.$store.state.app.showAlert;
            },
        },
        nombreUsuario: function () { return this.$store.state.auth.user.name },
        items: function () {

            return [{
                icon: 'home',
                title: 'Inicio',
                link: '/',
                show: true
            },
            {
                icon: 'phone',
                title: 'Contacto',
                link: '/contacto',
                show: true
            },
            {
                icon: 'calendar_today',
                title: 'Eventos',
                link: '/admin/evento/lista',
                show: this.isLoggedIn && this.isAdmin
            },
            {
                icon: 'attach_money',
                title: 'Pagos en revisión',
                link: '/admin/pagos/lista',
                show: this.isLoggedIn && this.isAdmin
            },
            {
                icon: 'person',
                title: 'Organizadores',
                link: '/admin/organizadores',
                show: this.isLoggedIn && this.isAdmin
            },
            {
                icon: 'person_outline',
                title: 'Admin',
                link: '/backoffice/dashboard',
                show: this.isLoggedIn
            },
            {
                icon: 'calendar_today',
                title: 'Mis Eventos',
                link: '/organizador/evento/lista',
                show: this.isLoggedIn && this.isOrganizador
            },
            {
                icon: 'person_outline',
                title: 'Novedades',
                link: '/organizador/home',
                show: this.isLoggedIn && this.isOrganizador
            }]
        }

    },
    name: 'App'
}
</script>

<style scoped>
.app-footer {
  background: #fff !important;
  border-top: 1px solid #e8e8e8;
}

/* Que el footer envuelva todo su contenido y el botón no flote fuera */
.app-footer,
.footer-inner,
.footer-container {
  display: block !important;
  width: 100%;
  box-sizing: border-box;
}

.footer-inner {
  width: 100%;
}

.footer-container {
  padding: 36px 16px 28px;
  max-width: 1000px;
  margin: 0 auto;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #eee;
}

.footer-brand {
  font-size: 1.125rem;
  font-weight: 700;
  color: #ff9800;
  text-decoration: none;
  letter-spacing: -0.02em;
}

.footer-brand:hover {
  color: #f57c00;
}

.footer-nav {
  display: flex;
  gap: 8px 20px;
}

.footer-nav-link {
  font-size: 0.9375rem;
  color: #424242;
  text-decoration: none;
}

.footer-nav-link:hover {
  color: #ff9800;
}

.footer-bottom {
  padding-top: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 16px;
  font-size: 0.8125rem;
  color: #757575;
}

.footer-auth {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-welcome {
  font-size: 0.875rem;
  color: #616161;
}

.footer-copy {
  color: #616161;
}

.footer-contact-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-contact-link {
  color: #757575;
  text-decoration: none;
}

.footer-contact-link:hover {
  color: #ff9800;
}

.footer-sep {
  color: #bbb;
  user-select: none;
}

.footer-btn-ingresar,
.footer-btn-salir {
  color: #424242 !important;
  font-size: 0.9375rem !important;
  text-transform: none;
  min-width: auto !important;
  margin: 0 !important;
  position: relative !important;
  display: inline-flex !important;
  flex-shrink: 0;
}

.footer-btn-ingresar:hover,
.footer-btn-salir:hover {
  color: #ff9800 !important;
  background: transparent !important;
}

@media (min-width: 600px) {
  .footer-container {
    padding: 44px 24px 36px;
  }

  .footer-top {
    padding-bottom: 28px;
  }

  .footer-bottom {
    padding-top: 28px;
  }

  .footer-bottom {
    justify-content: space-between;
  }
}

/* Botón flotante WhatsApp */
.whatsapp-float {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #25d366;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.5);
  transition: transform 0.2s, box-shadow 0.2s;
  text-decoration: none;
}

.whatsapp-float:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.55);
  color: #fff;
}

.whatsapp-float-icon {
  width: 32px;
  height: 32px;
  color: #fff;
}

@media (max-width: 600px) {
  .whatsapp-float {
    bottom: 20px;
    right: 20px;
    width: 52px;
    height: 52px;
    bottom: calc(20px + env(safe-area-inset-bottom));
    right: calc(20px + env(safe-area-inset-right));
  }

  .whatsapp-float .v-icon {
    font-size: 28px !important;
  }

  .whatsapp-float-icon {
    width: 28px;
    height: 28px;
  }
}
</style>
